import React, { useState, useEffect } from 'react';
import Menu from '../../Header/Menu';
import {
    CssBaseline,
    makeStyles,
    Grid,
    Card,
    CardActionArea,
    CardHeader,
    Avatar,
    Typography,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

const useStyles = makeStyles((theme) => ({
    root: {
        margin: theme.spacing(2),
    },
    card: {
        width: '100%',
    },
    avatar: {
        backgroundColor: theme.palette.primary.main,
        width: 45,
    },
    alert: {
        marginTop: theme.spacing(2),
    },
}));

export default function BarrierSettings() {
    const classes = useStyles();

    const [list, setList] = useState([]);
    const [portal, setPortal] = useState([]);
    const [currentBarrier, setCurrentBarrier] = useState(null);
    const [editName, setEditName] = useState('');
    const [editPortal, setEditPortal] = useState(0);
    const [editError, setEditError] = useState('');
    const [isEditMode, setIsEditMode] = useState(false);

    const handleLoad = () => {
        fetch(process.env.REACT_APP_API_URL + '/parking/barrier', {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => res.json())
            .then(res => setList(res.barrier));
    };

    const loadPortal = () => {
        fetch(process.env.REACT_APP_API_URL + '/parking/portal', {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => res.json())
            .then(res => {
                setPortal(res.portal);
                if (res.portal.length > 0) setEditPortal(res.portal[0].id);
            });
    };

    useEffect(() => {
        handleLoad();
    }, []);

    const handleSubmit = (action) => {
        let reqMethod;
        let reqBody;
        let reqUrl;
        switch (action) {
            case 'delete':
                reqMethod = 'DELETE';
                reqBody = null;
                reqUrl = process.env.REACT_APP_API_URL + '/parking/barrier/' + currentBarrier.id;
                break;
            case 'create':
                reqMethod = 'POST';
                reqBody = JSON.stringify({ "portal": editPortal, "name": editName });
                reqUrl = process.env.REACT_APP_API_URL + '/parking/barrier';
                break;
            case 'update':
                reqMethod = 'PUT';
                reqBody = JSON.stringify({ "portal": editPortal, "name": editName });
                reqUrl = process.env.REACT_APP_API_URL + '/parking/barrier/' + currentBarrier.id;
                break;
        }
        fetch(reqUrl, {
            method: reqMethod,
            credentials: 'include',
            body: reqBody,
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => {
                switch (res.status) {
                    case 403:
                        setEditError("Запрещено!");
                        setTimeout(() => setEditError(""), 2000);
                        break;
                    case 409:
                        setEditError("Такое уже есть!");
                        setTimeout(() => setEditError(""), 2000);
                        break;
                    default:
                        setCurrentBarrier(null);
                        handleLoad();
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

    const openDialog = (barrier = null) => {
        if (barrier) {
            setIsEditMode(true);
            setCurrentBarrier(barrier);
            setEditName(barrier.name);
            setEditPortal(barrier.portal);
        } else {
            setIsEditMode(false);
            setCurrentBarrier({});
            setEditName('');
            setEditPortal(portal.length > 0 ? portal[0].id : 0);
        }
        loadPortal();
    };

    const closeDialog = () => {
        setCurrentBarrier(null);
        setEditError('');
    };

    return (
        <React.Fragment>
            <Menu title='Барьеры' reloadData={handleLoad} />
            <CssBaseline />
            <div className={classes.root}>
                <Button variant="contained" color="primary" onClick={() => openDialog()}>
                    Новый барьер
                </Button>

                <Grid container spacing={1} style={{ marginTop: 16 }}>
                    {list.map((data, i) => (
                        <Grid container item xs={12} sm={6} md={4} lg={4} xl={2} key={i}>
                            <Card className={classes.card}>
                                <CardActionArea onClick={() => openDialog(data)}>
                                    <CardHeader
                                        avatar={
                                            <Avatar variant="rounded" className={classes.avatar}>
                                                <CheckCircleOutlineIcon />
                                            </Avatar>
                                        }
                                        subheader={
                                            <Typography variant="h5" component="h2">{data.name}</Typography>
                                        }
                                    />
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </div>

            <Dialog open={currentBarrier !== null} onClose={closeDialog} maxWidth="sm" fullWidth>
                <DialogTitle>{!isEditMode ? 'Новый барьер' : 'Редактировать барьер'}</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Название"
                        type="text"
                        fullWidth
                        value={editName}
                        onChange={(e) => setEditName(e.target.value)}
                        placeholder="Зезд на парковку"
                    />
                    <FormControl fullWidth margin="dense">
                        <InputLabel>Портал</InputLabel>
                        <Select
                            value={editPortal}
                            onChange={(e) => setEditPortal(e.target.value)}
                        >
                            {portal.map((data, j) => (
                                <MenuItem key={j} value={data.id}>
                                    {(data.from_areaT ? data.from_areaT : "Улица") + " - " + (data.to_areaT ? data.to_areaT : "Улица")}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    {editError && (
                        <Alert severity="error" className={classes.alert}>
                            {editError}
                        </Alert>
                    )}
                </DialogContent>
                <DialogActions>
                    {isEditMode && (
                        <Button onClick={() => handleSubmit('delete')} color="secondary">
                            Удалить
                        </Button>
                    )}
                    <Button onClick={closeDialog} color="primary">
                        Отмена
                    </Button>
                    <Button onClick={() => handleSubmit(isEditMode ? 'update' : 'create')} color="primary">
                        {isEditMode ? 'Сохранить' : 'Добавить'}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
